import { createSlice, PayloadAction, createSelector } from 'redux-starter-kit';
import { Resources, Mutations } from '@erecruit/types';

import { selectAppState } from '../../../App/state/selectors';

export interface PositionSearchPayload {
  data: Resources.PositionSearch[];
  totalCount: number;
}

export interface PositionSearchFilterData {
  positionTypes: Resources.PositionType[];
  worksites: Resources.Worksite[];
  contacts: Resources.Contact[];
}

export interface PositionSearchState extends PositionSearchPayload {
  isLoading: boolean;
  exporting?: boolean;
  error?: string;
}

const initialState: PositionSearchState = {
  isLoading: false,
  data: [],
  totalCount: 0,
};

const PositionSearchSlice = createSlice({
  slice: 'positionSearch',
  initialState: initialState,
  reducers: {
    searchPositions(
      state,
      // eslint-disable-next-line
      action: PayloadAction<Resources.PositionSearchParams>,
    ) {
      state.isLoading = true;
    },
    searchPositionsSuccess(
      state,
      action: PayloadAction<PositionSearchPayload>,
    ) {
      const { data, totalCount } = action.payload;
      state.data = data;
      state.totalCount = totalCount;
      state.isLoading = false;
    },
    searchPositionsFail(state, action: PayloadAction<string>) {
      state.error = action.payload;
    },
    exportPositions(
      state,
      // eslint-disable-next-line
      action: PayloadAction<
        Pick<Mutations.ExportPositionSearchParams, 'columns'> & {
          params: Mutations.ExportPositionSearchParams['positionSearchParams'];
        }
      >,
    ) {
      state.exporting = true;
    },
    // eslint-disable-next-line
    exportPositionsSuccess(state, action: PayloadAction) {
      state.exporting = false;
    },
    exportPositionsFail(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.exporting = false;
    },
  },
});

const {
  actions,
  reducer,
  selectors: { getPositionSearch },
} = PositionSearchSlice;

export const {
  searchPositions,
  searchPositionsFail,
  searchPositionsSuccess,
  exportPositions,
  exportPositionsFail,
  exportPositionsSuccess,
} = actions;
export const selectors = {
  selectPositionSearchState: createSelector(
    [selectAppState],
    getPositionSearch,
  ),
};
export default reducer;
